import React, { CSSProperties } from 'react';
import { ColorInputListItemValue } from './color-input-list-item-value';
import { ListItem } from '@/components/list-item';
import { Props } from './color-input-list-item-types';

export const ColorInputListItem: React.FC<Props> = ({
  item,
  onChange,
  value,
}) => {
  const inputID = `color-input-${item.value}`;
  return (
    <ListItem
      item={item}
      renderRightComponent={() => {
        return (
          <label htmlFor={inputID} style={inputLabelStyle}>
            <ColorInputListItemValue value={value} />
            <input
              id={inputID}
              onChange={(e) => onChange(e.target.value)}
              style={inputStyle}
              type="color"
              value={value ?? undefined}
            />
          </label>
        );
      }}
    />
  );
};

const inputStyle: CSSProperties = {
  // Add space between the input and the color picker
  bottom: -8,
  height: 'auto',
  left: 0,
  position: 'absolute',
  right: 0,
  top: 0,
  visibility: 'hidden',
  width: 'auto',
};

const inputLabelStyle: CSSProperties = {
  cursor: 'pointer',
};
